function initHeader() {
  document.addEventListener("DOMContentLoaded", () => {
    const dropdownBtn = document.querySelector(".c-account-initials-btn");

    if (dropdownBtn) {
      const dropdownParent = dropdownBtn.closest(".c-account-dropdown");

      dropdownBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        if (dropdownParent) {
          dropdownParent.classList.toggle("show");
        }
      });

      // Close if clicking outside
      document.addEventListener("click", () => {
        if (dropdownParent) {
          dropdownParent.classList.remove("show");
        }
      });
    }
  });
}

initHeader();

export { initHeader };
